<template>
  <!--主界面公共头-->
  <div class="header_div">
    <el-row :gutter="0">
      <el-col :span="12">
        <img src="../assets/logo.jpg" width="371" height="auto" style="cursor: pointer" @click="to_home"/>
        <img src="../assets/logo_sub.jpg" width="185" height="auto" style="cursor: pointer" @click="to_home"/>
      </el-col>
      <el-col :span="12">
        <el-menu
          :default-active=" default_index11 "
          text-color="#333333"
          active-text-color="#E71489"
          class="el-menu-demo menu-div"
          mode="horizontal"
          @select="handleSelect">
          <el-menu-item index="1">品牌介绍</el-menu-item>
          <el-menu-item index="2">精彩视频</el-menu-item>
        </el-menu>
      </el-col>
      <!-- <el-col :span="1">
        <div class="right-icon-div">
          <i class="el-icon-s-home"></i>
          <i class="el-icon-chat-dot-round"></i>
          <i class="el-icon-search"></i>
        </div>
      </el-col> -->
    </el-row>

  </div>
</template>

<script>
export default {
  name: 'about_header',
  props:{
    default_index11: {    //默认选中的下标
      type:String,
      require: false,
      default:''
    }
  },
  methods: {
    to_home () {
      this.activeIndex = ''
      this.$router.push({path: '/'})
    },
    handleSelect (key, keyPath) {
      console.log("-=-=-=", key)
      if (key == '1') {  //品牌介绍
        this.$router.push({path: '/secth/about'})
      } else if (key == '2') {   //精彩视频
        this.$router.push({path: '/secth/vedio'})
      }
    }
  }
}
</script>

<style scoped lang="scss">

/deep/ .el-menu-item {
  font-size: 12pt;
  color: #303133;
  padding: 0 20px;
  cursor: pointer;
  -webkit-transition: border-color .3s, background-color .3s, color .3s;
  transition: border-color .3s, background-color .3s, color .3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.menu-div {
  margin-top: 18px;
  font-size: 12pt;
  font-weight: 300;
}
.header{
  overflow: hidden;
  position: fixed;
  z-index: 1000;
  top: 0;
  width: 100%;
  height: 80px;
  min-width: 1220px;
}
.header_div {
  width: 100%;
  height: 80px;
  background-color: #fff;
  position: fixed;
  top: 0px;
  z-index: 1000;
  text-align: left;
  min-width: 1220px;
}

.header_left_div {
  float: left;
  width: 55%;
  height: 100%;
}

.header_right_div {
  float: left;
  width: 45%;
  height: 100%;
}

.header_font_border {
  height: 100%;
  width: 100px;
  color: black;
  text-align: center;
  padding-top: 30px;
  font-size: 18px
}

.right-icon-div {
  padding-top: 28px;
  font-size: 28px;
  color: #666666
}
</style>



// WEBPACK FOOTER //
// src/components/header_thr_about.vue